// What the organization configures about its library: its own settings, and under `inheritable` the
// organization's level of the sixteen a workspace may override. Read by any member; changed and
// reset with `tenancy.settings.manage`.

import { api } from '../client'
import type { components } from '../schema'

export type OrgAssetSettingsView = components['schemas']['OrgAssetSettingsView']
export type UpdateOrgAssetSettingsRequest = components['schemas']['UpdateOrgAssetSettingsRequest']

/** The organization's settings; the platform's defaults for one that never configured anything. */
export function getOrgAssetSettings(signal?: AbortSignal): Promise<OrgAssetSettingsView> {
  return api.get<OrgAssetSettingsView>('/orgs/current/asset-settings', undefined, signal)
}

/**
 * Change them; a field left out is left alone. `null` clears the fields that can be empty — a
 * quota, the VAST tag, a logo — and reads as absent on the rest. 400 for advertising on with no
 * VAST tag, or a restriction to an empty allowlist.
 */
export function updateOrgAssetSettings(request: UpdateOrgAssetSettingsRequest): Promise<OrgAssetSettingsView> {
  return api.patch<OrgAssetSettingsView>('/orgs/current/asset-settings', request)
}

/** Back to the platform's defaults, whole. The workspaces' own overrides are untouched. */
export function resetOrgAssetSettings(): Promise<undefined> {
  return api.del<undefined>('/orgs/current/asset-settings')
}
